module.exports = __webpack_public_path__ + "assets/img/bg_all_marketing.a21e6095.jpg";